module.exports = __webpack_public_path__ + "static/slide7-743x573-c3f42d0edf083471020f45df39cae1c2.gif";